import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { f as e, m as t } from "../../../../chunks/vec2.js";
import { LineConstraint as r } from "../SnappingConstraint.js";
import { SnappingCandidate as n } from "./SnappingCandidate.js";
import { LineSnappingHint as i } from "../hints/LineSnappingHint.js";
import { ParallelSnappingHint as s } from "../hints/ParallelSnappingHint.js";

var a = /*#__PURE__*/function (_n) {
  _inherits(a, _n);

  var _super = _createSuper(a);

  function a(_ref) {
    var _this;

    var n = _ref.coordinateHelper,
        i = _ref.referenceLine,
        s = _ref.lineStart,
        _a = _ref.targetPoint;

    _classCallCheck(this, a);

    var f = n.clone(s);
    e(f, t(f, f, i.rightVertex.pos), i.leftVertex.pos), _this = _super.call(this, n, _a, new r(n, s, f)), _this._referenceLines = [{
      edge: i,
      fadeLeft: !0,
      fadeRight: !0
    }];
    return _this;
  }

  _createClass(a, [{
    key: "hints",
    get: function get() {
      return [new i(0, this.constraint.start, this.targetPoint), new s(this.constraint.start, this.targetPoint)].concat(_toConsumableArray(this._referenceLines.map(function (e) {
        return new i(1, e.edge.leftVertex.pos, e.edge.rightVertex.pos, e.fadeLeft, e.fadeRight);
      })));
    }
  }, {
    key: "addReferenceLine",
    value: function addReferenceLine(e) {
      var t = {
        edge: e,
        fadeLeft: !0,
        fadeRight: !0
      };
      this._referenceLines.forEach(function (r) {
        e.rightVertex.rightEdge === r.edge && (r.fadeLeft = !1, t.fadeRight = !1), e.leftVertex.leftEdge === r.edge && (r.fadeRight = !1, t.fadeLeft = !1);
      }), this._referenceLines.push(t);
    }
  }]);

  return a;
}(n);

export { a as ParallelLineSnappingCandidate };